export const ANSWER_ROUTE_OPERATION_NAME = 'KnowledgeDiscoveryAnswerRoute';
export const KnowledgeDiscoveryAnswerRouteQuery: '\n  query KnowledgeDiscoveryAnswerRoute(\n    $siteId: String!\n    $query: String!\n    $locale: String!\n    $metadata: KnowledgeDiscoveryMetadata\n    $orgId: String\n  ) {\n    knowledgeDiscovery {\n      smartAnswersRoute(\n        siteId: $siteId\n        query: $query\n        locale: $locale\n\t\t\t\tmetadata: $metadata\n\t\t\t\torgId: $orgId\n      ) {\n        __typename\n        ... on KnowledgeDiscoverySmartAnswersRoute {\n          route\n          transformedQuery\n        }\n        ... on QueryError {\n          message\n          extensions {\n            errorType\n            statusCode\n          }\n        }\n      }\n    }\n  }\n' = `
  query ${ANSWER_ROUTE_OPERATION_NAME}(
    $siteId: String!
    $query: String!
    $locale: String!
    $metadata: KnowledgeDiscoveryMetadata
    $orgId: String
  ) {
    knowledgeDiscovery {
      smartAnswersRoute(
        siteId: $siteId
        query: $query
        locale: $locale
				metadata: $metadata
				orgId: $orgId
      ) {
        __typename
        ... on KnowledgeDiscoverySmartAnswersRoute {
          route
          transformedQuery
        }
        ... on QueryError {
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
